/**
 * @fileoverview Ticker Implementation
 * @description Implements a continuously scrolling ticker using Swiper.js for horizontal text or image slides
 *
 * Dependencies:
 * - jQuery
 * - Swiper.js
 *
 * HTML Structure Required:
 * - Element with class "ticker" containing:
 *   * data-ticker-id: Unique identifier for the ticker
 *   * data-ticker-speed: Speed of the ticker in seconds
 *   * Element with class "ticker-js-{tickerId}" for the Swiper instance
 */

(function () {
  /**
   * @function tickSlider
   * @description Initializes and configures the ticker slider for each ticker element
   */
  const tickSlider = () => {
    $('.ticker').each(function () {
      const $this = $(this);
      const id = $this.attr('id');
      const tickerId = $this.data('ticker-id');
      const tickerSpeed = $this.data('ticker-speed') * 1000;
      const tickerSwiper = new Swiper(`#${id} .ticker-js-${tickerId}`, {
        slidesPerView: 'auto',
        speed: tickerSpeed,
        initialSlide: 0,
        loop: true,
        allowTouchMove: false,
        waitForTransition: false,
        watchSlidesProgress: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });
    });
  };

  // Initialize on Shopify section load and after a short delay
  document.addEventListener('shopify:section:load', function () {
    setTimeout(() => {
      tickSlider();
    }, 100);
  });
  setTimeout(() => {
    tickSlider();
  }, 100);
})();
